<template>
  <div class="d-flex-column justify-start align-start gap-5">
    <div class="d-flex-row justify-start gap-5">
      <label for="" class="t-light regular-l font-family-2">
        {{ title || $t("membership.extra") }}
      </label>
    </div>

    <div
      class="d-flex-row justify-start width-max-content"
      v-for="multiOption in getKeyedPlayoffs"
      :key="multiOption"
    >
      <Checkbox
        variant="secondary"
        type="extra_option"
        :is-checked="isChecked(multiOption.id)"
        :emit-function="emitTrial"
        :selectable-value="multiOption"
        :emit-function-key="multiOption.title"
      />
      <label
        class="medium-l font-family-2 t-white cursor-pointer"
        @click.stop="selectPlayoff(multiOption)"
        >{{ multiOption.title }}
        <span class="t-blue" style="text-transform: capitalize">{{
          renderPrice(multiOption)
        }}</span></label
      >
      <ItemTooltip :text="multiOption.description" />
    </div>
  </div>
</template>

<script setup>
import Checkbox from "~/components/custom/Checkbox.vue";
import ItemTooltip from "../../fc-25/pickers/ItemTooltip.vue";

const props = defineProps({
  selectOne: {
    default: false,
  },
  keys: {
    default: [
      "the_war_within_campaign",
      "khaz_algar_loremaster",
      "khaz_algar_skyriding_glyphs",
      "khaz_algar_storyline",
    ],
  },
  title: {
    default: "",
  },
});

const gameStore = useGameStore();
const checkoutStore = useCheckoutStore();

const getKeyedPlayoffs = computed(() => {
  return gameStore.getGamePack?.pack_options?.filter((op) =>
    props.keys.includes(op.const_title)
  );
});
const isChecked = (optionId) => {
  return checkoutStore.getPackOptions?.includes(optionId);
};

const isOptionSelected = (packOption) => {
  const selectedOption = checkoutStore.getPackOptions.find(
    (option) => option === packOption
  );
  if (!selectedOption) {
    return false;
  }
  return true;
};

const selectPlayoff = (option) => {
  if (!isOptionSelected(option.id)) {
    checkoutStore.removePackOption({
      optionIds: option?.rules?.disable || [],
    });

    checkoutStore.setPackOptions({
      options: [...checkoutStore.getPackOptions, option.id],
    });
  } else {
    const otherOptions = checkoutStore.getPackOptions.filter(
      (packOpt) => packOpt !== option.id
    );

    checkoutStore.setPackOptions({
      options: [...otherOptions],
    });
  }
};

const emitTrial = (key, value) => {
  selectPlayoff(value);
};
</script>

<style lang="scss" scoped>
.wow-addon-picker {
  display: flex;
  height: 40px;
  padding: 0px 12px;
  justify-content: space-between;
  align-items: center;
  gap: 11px;
  flex-shrink: 0;
  align-self: stretch;
  border: 1px solid var(--Stroke-Medium, #27292b);
  background: var(--BG-Medium, #121517);
  position: relative;
  &.errored {
    border: 1px solid var(--path-of-exile);
    background: var(--path-of-exile-opace);
  }
  .divisions_list_container {
    position: absolute;
    top: 105%;
    left: 0%;
    width: 100%;
    height: max-content;
    max-height: 30vh;
    overflow: auto;
    background-color: var(--bg-medium);
    border: 1px solid var(--stroke-medium);
    z-index: 9999;
    border-radius: 3px;
    -moz-border-radius: 3px;
    -webkit-border-radius: 3px;
    padding: 6px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    z-index: 10;
    gap: 6px;
    .item {
      width: 100%;
      height: 48px;
      outline: none;
      border: none;
      text-align: start;
      padding: 11px;
      border-radius: 3px;
      -moz-border-radius: 3px;
      -webkit-border-radius: 3px;
      cursor: pointer;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 5px;
      z-index: 1;
      @media screen and (max-width: 480px) {
        padding: 16px;
      }

      &.active_item {
        background-color: var(--bg-main);
        color: var(--white);
      }
    }
  }
}
</style>
